<template>
    <!-- 中心业务 -->
    <div class="business">
        <div class="banner">
            <h2 class="title">协作工程</h2>
            <ul class="menu-list flex-align">
                <li v-for="(item,index) in menuList" :key="index" class="menu-item csp"
                    :class="{'active-menu':activeMenu == index}" @click="chooseMenu(index)">
                    {{item.title}}
                </li>
            </ul>
        </div>
        <div class="business-inner flex-layout">
            <div class="sidebar">
                <!-- <h4 class="sidebar-title">{{menuList[activeMenu].title}}</h4> -->
                <ul class="sidebar-list">
                    <li class="sidebar-itme flex-align" v-for="(each,index) in menuList[activeMenu].childList"
                        :key="index" :class="{'acitve-sidebar-item':activeSideBarItem == index}"
                        @click="chooseSidebar(index)">
                        <img class="sidebar-icon" :src="activeSideBarItem == index?each.activeIcon : each.icon" alt="">
                        <p class="sidebar-name">{{each.name}}</p>
                    </li>
                </ul>
            </div>
            <div class="container">
                <div style="display:flex;align-items:center">
                    <h3 class="sub-title">{{menuList[activeMenu].childList[activeSideBarItem].name}}</h3>
                    <div class="join" v-if="menuList[activeMenu].childList[activeSideBarItem].name=='教师队伍素养提升工程'||
                    menuList[activeMenu].childList[activeSideBarItem].name=='课堂教学数字化工程'||
                    menuList[activeMenu].childList[activeSideBarItem].name=='教学评估督导智能化工程'">
                        <el-button type="text" style="margin-left:10px"
                            @click="join(menuList[activeMenu].childList[activeSideBarItem].name)">进入</el-button>
                    </div>
                </div>

                <div class="detail">

                    <p class="text" v-html="menuList[activeMenu].childList[activeSideBarItem].content"
                        v-if="menuList[activeMenu].childList[activeSideBarItem].name=='教育协作智慧平台建设工程'"></p>
                    <div class="box" v-if="menuList[activeMenu].childList[activeSideBarItem].name=='民族团结和生态实践研学工程'">
                        <div class="addr">
                            <span>区域:</span>
                            <span>呼和浩特</span>
                            <span>锡林郭勒</span>
                            <span>乌兰察布</span>
                        </div>
                        <div class="type">
                            <span>分类:</span>
                            <span>自然</span>
                            <span>人文</span>
                        </div>
                        <div class="imgs">
                            <div class="items" v-for="(item,index) in imgs" :key="index" @click="goDetail(item.name,item.id)">
                                <img :src="downloadURLImg+item.cover" alt="">
                                <span>{{item.name}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="box2" v-if="menuList[activeMenu].childList[activeSideBarItem].name=='教师队伍素养提升工程'">
                        <p>在北京市教委、内蒙古教育厅引领下，基于平台，构建“131”京蒙教师五年同步成长计划，以“同步课堂，同步教研，同步成长”为主线，发挥首都师范大学专业优势，统筹各区教育协作项目，基于“一周一课堂、一月一主题、一年一递进”对课程进行规划，服务广大教师。同时，根据各区各校实际情况，提供丰富的提质培优项目服务，切实为内蒙古培养出一支“带不走”的教师队伍。
                        </p>
                        <b style="display:flex;align-items:center">
                            <i class="el-icon-reading" style="color:#409EFF;font-size:24px;margin-right:10px"></i>
                            一周一课 ——同频同振 同步课堂</b>
                        <p>搭建“零时差”“互联网+同步课堂”，实现自治区、盟市、旗县、乡村学校的四级同步课堂，将京蒙两地师生紧紧相连。</p>
                        <img src="../assets/jm/10.jpg" alt="">
                        <b style="display:flex;align-items:center">
                            <i class="el-icon-reading" style="color:#409EFF;font-size:24px;margin-right:10px"></i>
                            一月一专题 ——共研共享 同步教研</b>
                        <span>搭建“互联网+同步教研”空间，每月围绕一专题，云端开展协同备课、集体说课、公开课、听评课等系列教研活动，精准补短板，快速促提升。</span>
                        <img src="../assets/jm/11.jpg" alt="">

                        <b style="display:flex;align-items:center">
                            <i class="el-icon-reading" style="color:#409EFF;font-size:24px;margin-right:10px"></i>
                            一年一递进 ——提质增效 同步成长</b>
                        <span>策划开展“驼铃”杯年度教师教学能力大赛，沉淀、展示参训教师年度成果，示范引领当地普通教师发展。同时，科学诊断参训教师提升情况，深化下一年度培训内容，层层递进，节节拔高。</span>
                        <img src="../assets/jm/12.jpg" alt="">
                    </div>
                    <div class="box2" v-if="menuList[activeMenu].childList[activeSideBarItem].name=='创新拔尖人才培育工程'">
                        <p>对标新高考综合改革，服务国家人才发展战略，以创新素养为核心，基于平台，开展创新拔尖人才培育，贯通中小学育人路径，助力内蒙古培育一批新时代创新型人才。</p>
                        <b style="display:flex;align-items:center">
                            <i class="el-icon-reading" style="color:#409EFF;font-size:24px;margin-right:10px"></i>
                            中小学人工智能素养提升</b>
                        <p>面向对口帮扶的中小学实施包含人工智能素养提升项目，包括优质课程资源、师资培训和赛事运营等内容，助力中小学生夯实人工智能素养、拓展创新能力。</p>
                        <p>1、精品课程</p>
                        <img src="../assets/jm/13.jpg" alt="">
                        <p>2、师资培训</p>
                        <p>解决人工智能教育师资不足问题，建立本地化教师队伍。赛事运营等内容，助力中小学生夯实人工智能素养、拓展创新能力。</p>
                        <img src="../assets/jm/14.jpg" alt="">
                        <p>3、赛事活动</p>
                        <p>通过赛课一体机制，打通学习出口，激发学生动力。</p>
                        <img src="../assets/jm/15.jpg" alt="">
                        <b style="display:flex;align-items:center">
                            <i class="el-icon-reading" style="color:#409EFF;font-size:24px;margin-right:10px"></i>
                            新高考优才培养</b>
                        <p>为全面诊断学生情况，选拔优秀学苗，针对性制定三年学业生涯规划，助力内蒙古更多的学生考入国家重点高校。</p>
                        <p>1、学业生涯规划</p>
                        <p>通过对中学生自身性格特点、能力特点和未来社会需要的全面了解，确定人生阶段性职业和事业目标，解决中学生为什么学、学什么、怎么学、什么时候学、在哪里学问题。</p>
                        <img src="../assets/jm/16.jpg" alt="">
                        <img src="../assets/jm/17.jpg" alt="">
                        <p>2、优学培养课程</p>
                        <p>将强基笔试要求、高考要求和高中教学进度相融合使学生通过2-3年的学习不但可以在高考中不断实现突破，更能够在强基笔试中脱颖而出。</p>
                        <div>
                            <img src="../assets/jm/18.jpg" alt="">
                            <img src="../assets/jm/19.jpg" alt="">
                        </div>
                        <div>
                            <img src="../assets/jm/20.jpg" alt="">
                            <img src="../assets/jm/21.jpg" alt="">
                        </div>

                        <p>3、高考冲刺密卷</p>
                        <p>参考课程标准和考试说明，从个人的学情出发，将各部分知识进行有机整合，删繁就简，通过专项训练，养成一定的思维能力和解题能力，从知识体系搭建跃迁到解题能力突破。</p>
                        <div>
                            <img src="../assets/jm/22.jpg" alt="">
                            <img src="../assets/jm/23.jpg" alt="">
                        </div>
                        <p>4、科研活动</p>
                        <p>培养学生学术科研能力，提升升学申请的科研成果竞争力。</p>
                        <img src="../assets/jm/24.jpg" alt="">

                    </div>
                    <div class="box2" v-if="menuList[activeMenu].childList[activeSideBarItem].name=='课堂教学数字化工程'">
                        <p>依据新课程标准，实施读写筑基行动，通过“首师优字”“零基础识写课堂”开展分享式智慧读写教学项目，提升师生的国家通用语言文字应用能力，举行系列主题活动，增进京蒙两地师生交流，共同筑牢中华民族共同体意识。
                        </p>
                        <b style="display:flex;align-items:center">
                            <i class="el-icon-reading" style="color:#409EFF;font-size:24px;margin-right:10px"></i>
                            “首师优字”国通语规范字书写项目</b>
                        <p>“首师优字”是教育部“经典润乡土计划”重点项目，已在新疆和田、北京海淀、房山密云等地大面积应用，高效促进师生国家通用语言文字应用能力提升，助力学校落实新课标、践行“五育并举”。</p>
                        <p>1、构建基于诊断性评价的教师培训模式</p>
                        <p>依托智能型伴随式诊断，准确分析教师书写能力起点，通过大数据精准指导，保障实效性和针对性。</p>
                        <img src="../assets/jm/25.jpg" alt="">
                        <p>2、打造高效写练评机制共同体</p>
                        <p>以“少写、精练、高效、轻负”为目标，构建“专家+师范生+参训教师+学生”研学共同体，增进交流，快速提升。</p>
                        <img src="../assets/jm/28.jpg" alt="">
                        <p>3、供给“互联网+零基础汉字识写课堂”</p>
                        <p>提供可大面积推广的零备课、零专业能力、零添置、强互动、强实效、强数据的零基础汉字读写课堂及配套教学物料，创设师生共学环境，促进师生同练同提升。</p>
                        <img src="../assets/jm/30.jpg" alt="">
                        <p>4、打造“文化润心 书写育人”系列展示活动</p>
                        <p>京蒙携手开展师生诵读、书写、教师公开课展示、项目成果汇报等活动，为师生提供更高、更广的展示平台，并向全国大赛推荐，助力获得优异成绩。</p>
                        <img src="../assets/jm/35.jpg" alt="">
                         <b style="display:flex;align-items:center">
                            <i class="el-icon-reading" style="color:#409EFF;font-size:24px;margin-right:10px"></i>
                            “乐智悦读”分享式共读项目</b>
                        <p>融合智慧阅读软硬件配置、资源供给、活动激趣、互动交流等方面的，嵌入素养评价，形成了课内外、线上线下、家校一体化的阅读教育教学新范式，助力宁夏银川等地形成丰富阅读成效，以校园阅读有效带动全民阅读。
                        </p>
                        <p>1、构建智慧共读网络，让校园阅读能悦读</p>
                        <img src="../assets/jm/40.jpg" alt="">
                        <p>2、开展智慧共读活动，让全民阅读乐悦读</p>
                        <img src="../assets/jm/41.jpg" alt="">
                        <p>3、完善制度机制，让全民阅读长悦读</p>
                        <img src="../assets/jm/42.jpg" alt="">
                        <p>4、作品展示</p>
                        <img src="../assets/jm/43.jpg" alt="">
                        <img src="../assets/jm/44.jpg" alt="">
                        <p>5、成果出版</p>
                        <img src="../assets/jm/45.jpg" alt="">
                        <img src="../assets/jm/46.jpg" alt="">
                        <p>6、宣传推广</p>
                        <img src="../assets/jm/47.jpg" alt="">
                        <img src="../assets/jm/48.jpg" alt="">
                    </div>
                    <div class="box2" v-if="menuList[activeMenu].childList[activeSideBarItem].name=='教学评估督导智能化工程'">
                        <p>以教育治理能力提升为切入点，发挥数据赋能作用，构建基于信息技术的现代化教育治理模式，形成同研究、同部署、同落实、同督导、同考核的教育治理能力提升机制，促进内蒙古自治区教育教学评价改革创新。
                        </p>
                        <img src="../assets/jm/49.jpg" alt="" style="width:700px">
                        <img src="../assets/jm/50.jpg" alt="" style="width:700px">
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import DoApi from '../config/utils/DoApi';

    export default {
        data() {
            return {
                activeMenu: 0,
                activeSideBarItem: 0,
                menuList: [{
                        title: '数字化基础建设',
                        childList: [{
                                name: '教育协作智慧平台建设工程',
                                icon: require("../assets/business/icon01.png"),
                                activeIcon: require("../assets/business/choose-icon01.png"),
                                content: `<p>为顺应教育变革趋势，推进京蒙教育协作数字化转型，打造“京蒙教育协作智慧平台”（以下简称平台），
                                发挥数字信息技术放大、叠加、倍增、持续溢出作用，促进帮扶增量、提质、增效，形成“一次帮扶，全域受益”的京蒙教育协作新格局。</p>
                                <b>一、工作目标</b> <br>
                                <p>以平台为驱动，推进京蒙教育协作的数字化转型升级，实现京蒙线上线下教育协作项目有机融合，成为京蒙教育协同发展的“倍增器”和新的增长极。
                                平台建成后，既可加大线下帮扶项目信息化管理，使帮扶工作增量、提质；又可面向内蒙古全域提供资源共享、在线研修、协同教研、双师课堂、听评课、
                                公开课与直播等服务，让帮扶的成效产生几何倍增的效应。</p>
                                <b>二、平台功能</b> <br>
                                <p>（一）融合课程资源</p></br>
                                <p>汇聚与北京中小学同步的最新最优课程资源、授课资源、作业与题库资源。让每一位教师“教”有资源，让每一位学生“学”有课程。平台保存京蒙教育协作过程中的专家指导课程
                                、教师研修成果、学生作品等资源，通过资源激励机制，引导教师分享、应用资源，形成资源的规模复用效应，促进成效倍增。</p>
                                 <p>（二）支持教师研修</p></br>
                                <p>为教师网络研修提供全面的支持和服务，教师通过电脑或手机可随时随地参与“线上送课”“在线走教”“双师课堂”“协同教研”等教学、研修活动，平台智能评估教师专业能力水平，精准匹配研修课程，指引教师持续发展。</p>
                                 <p>（三）支撑教学开展</p></br>
                                <p>提供备授课资源、互动工具。覆盖课前、课中、课后，打通教材资源、课前导学、同步备课、互动课堂、在线检测、课后作业各环节，支撑教与学的全过程。</p>
                                 <p>（四）赋能综合评价</p></br>
                                <p>落实义务教育质量评价指南、普通高中办学质量评价指南。精准诊断学生学科素养，助力教师掌握班级学情，改进教学方法；使学校掌握教情，优化教学管理；使教育部门全面及时掌握区域内各校教学情况，为教育决策提供依据，助力教育治理现代化。</p>
                                `
                            },
                            {
                                name: '教师队伍素养提升工程',
                                icon: require("../assets/business/icon02.png"),
                                activeIcon: require("../assets/business/choose-icon02.png"),
                                content: `<p>在北京市教委、内蒙古教育厅引领下，基于平台，构建“131”京蒙教师五年同步成长计划，以“同步课堂，同步教研，同步成长”为主线，发挥首都师范大学专业优势
                                统筹各区教育协作项目，基于“一周一课堂、一月一主题、一年一递进”对课程进行规划，服务广大教师。同时，根据各区各校实际情况，提供丰富的提质培优项目服务，切实为内蒙古培养出一支“带不走”的教师队伍。</p>
                                
                                `

                            },
                            {
                                name: '创新拔尖人才培育工程',
                                icon: require("../assets/business/icon03.png"),
                                activeIcon: require("../assets/business/choose-icon03.png"),
                                content: `<p>服务国家人才发展战略，以创新素养为核心，基于平台，开展创新拔尖人才培育，助力内蒙古培育一批新时代创新型人才。</p>
                                <b>一、工作目标</b> <br>
                                <p>以新高考综合改革为着眼点，贯通基础教育和高等教育人才培养链。聚焦中小学生创新素养提升，筑牢基础教育根基，培育出全面发展的创新型学生，为普高和职高育苗。面向普高和职高分别开展人才培育，加强两地高校交流，形成具有京蒙教育协作特色的协同育人模式。</p>
                                <b>二、工作内容</b> <br>
                                <p>（一）提升中小学生创新素养，形成一批优秀作品成果</p></br>
                                <p>面向对口帮扶的中小学实施包含人工智能素养提升、计算思维培养、STEAM教育等内容的创新素养培育项目，助力中小学生夯实基础、拓展能力。</p>
                                 <p>（二）实施优才培养计划，助力普高优秀学生提升高考成绩</p></br>
                                <p>落实县域高中振兴计划，结合新高考的拔尖创新人才选拔特点，普通高中学生，开展优才培养计划，进行学科培优，提高优秀学生的高考成绩，使内蒙古更多的学生考入国家重点高校。</p>
                                 <p>（三）校企联合培养，提高职高学生就业质量</p></br>
                                <p>与名企合作，面向对口帮扶的职业高中，开展专业联合培养。采用“1年学基础、1年学技能、1年实习实训”的“三段式”培养模式，提高学生就业质量，打造产教融合新品牌。</p>
                                <p>（四）推动京蒙高校交流，促进两地院校合作</p></br>
                                <p>结合北京“四个中心”和内蒙古“五大任务”建设发展需求，支持更多京蒙高校开展共建交流，深化合作内涵。加大高端人才联合培养、学术交流力度，共享科学研究、课程建设等资源，实现互利共赢。</p>`

                            },
                            {
                                name: '课堂教学数字化工程',
                                icon: require("../assets/business/icon04.png"),
                                activeIcon: require("../assets/business/choose-icon04.png"),
                                content: `<p>新高考、新课标进一步加强了对中小学生的阅读书写能力的要求，但当前仍有不少教师教不好读写，导致学生学不好、能力难以提升。为贯彻落实《义务教育课程方案和课程标准(2022年版)》，在探索课堂教学数字化转型方式的同时，以阅读书写为核心，以项目式学习为形式，开展读写筑基行动，增进京蒙两地师生交流，传承中华经典文化，共同筑牢中华民族共同体意识。</p>
                                <b>一、工作目标</b> <br>
                                <p>基于平台，优先实施读写筑基行动，开展分享式智慧读写教学项目，覆盖课中、课外活动及课后服务场景，数字化技术赋能教学各过程。积极探索课堂教学数字化转型方式，通过实践，形成可复制、可推广的课堂教学数字化模式，逐步扩大覆盖面，使内蒙古更多的师生受益。</p>
                                <b>二、工作内容</b> <br>
                                <p>（一）探究数字化教学推进路径</p></br>
                                <p>以读写为抓手，向对口协作学校输送“零基础读写课堂”，在专家的贴身指导下，形成探究新型的数字化读写教学推进路径和模式。</p>
                                 <p>（二）培养适应数字化变革的优秀教师</p></br>
                                <p>建立“一线名师—种子教师—普通教师”的协同模式，发挥内蒙古种子教师示范作用，促进更多普通教师教学理念及教学行为的转变，培养适应数字化变革的教师梯队。</p>
                                 <p>（三）生成可复制、可推广的数字化教学模式</p></br>
                                <p>建立项目资源库，指导内蒙古教师总结、固化实践成果，形成具有推广功能的包含教学设计、课件、教学视频、学生作品等资源包，形成可复制可推广的数字化教学推进模式，引导其他学科教师利用模式，开展数字化教学探索。</p>
                               `
                            },
                            {
                                name: '教学评估督导智能化工程',
                                icon: require("../assets/business/icon05.png"),
                                activeIcon: require("../assets/business/choose-icon05.png"),
                                content: `<p>聚焦新时代教育高质量发展的新要求，发挥智慧平台的赋能作用，引导内蒙古自治区学校、区域构建符合自身发展的智能化教学评估督导机制，形成具有内蒙古特色的可复制、可推广的智能化教学评估督导新模式。</p>
                                <b>一、工作目标</b> <br>
                                <p>发挥数据赋能作用，建立班级、学校、区域三级教学评估体系，形成同研究、同部署、同落实、同督导、同考核的智能化督导机制，促进内蒙古自治区教育教学评价改革创新。</p>
                                <b>二、工作内容</b> <br>
                                <p>基于平台，面向内蒙古中小学提供课堂教学评价大数据可视化分析。服务教师精准教学，助力教师因材施教，促进教师减负增效。服务学校精细化管理，动态掌握学校教学情况，及时调整管理策略。服务教育行政部门教学评估督导，准确监测区域内各学校教学开展质量，提升教育治理能力。</br>`
                            },
                            {
                                name: '民族团结和生态实践研学工程',
                                icon: require("../assets/business/icon01.png"),
                                activeIcon: require("../assets/business/choose-icon01.png")
                            },
                        ]
                    },
                    {
                        title: '教师素养提升',
                        childList: [{
                            name: '教师1'
                        }],
                    },
                    {
                        title: '创新人才培养',
                        childList: [{
                            name: '教师1'
                        }],
                    },
                    {
                        title: '教学评价革新',
                        childList: [{
                            name: '教师1'
                        }],
                    },
                    {
                        title: '课堂教学过程数字化',
                        childList: [{
                            name: '教师1'
                        }],
                    }
                ],
                imgs: []
            }
        },
        methods: {
            chooseMenu(index) {
                this.activeMenu = index;
            },
            chooseSidebar(index) {
                this.activeSideBarItem = index;
            },
            join(name) {
                // console.log('join:',name)
                if (name == '教师队伍素养提升工程') {
                    console.log('跳转研修平台');
                    // window.open("https://jm.cnuen.net/login?un=13641301911&pd=Syyq123456@&origin=jm");
                    window.open(
                        "https://jm.cnuen.net/login?un=18131405634&pd=Syyq123456@&origin=jm&keyCode=d63becec70f41c0ae20bca40e81f81dc&captchaCode=rgdzf"
                    );
                } else if (name == '课堂教学数字化工程') {
                    console.log('跳转优字');
                    window.open("https://yun.cnuzi.com/logins?un=15920161010&pd=123456&origin=jm");
                } else if (name == '教学评估督导智能化工程') {
                    this.$router.push({
                        path: '/tabel',
                    })
                }
            },
            goDetail(name,id) {
                let query = {
                    name,
                    id
                };
                this.$router.push({
                    path: '/detail',
                    query
                })
            },
            // 获取研学基地列表
            getImgs(){
                Api.Home.GetAddress()
                    .then(res=>{
                        console.log('基地:',res);
                        this.imgs = res.data
                    })
                    .catch(err=>{
                        console.log('err:',err)
                    })
            }
        },
        mounted(){
            this.activeSideBarItem = this.$route.query.index;
            this.getImgs()
        }
    }
</script>

<style lang="less" scoped>
    .business {
        .banner {
            background-image: url("../assets/business/banner.jpg");
            background-repeat: no-repeat;
            background-size: 100% 100%;
            height: 27.6%;
            padding-left: 6.9%;

            .title {
                padding-top: 9.3%;
                font-size: 48px;
                color: #fff;
                margin-bottom: 2.5%;
                letter-spacing: 2px;
            }

            .menu-list {
                padding-right: 59%;
                flex-wrap: wrap;
                visibility: hidden;
            }

            .menu-item {
                color: #fff;
                font-size: 30px;
                margin-bottom: 7.3%;
                letter-spacing: 2px;
                position: relative;
                width: 45%;

                &:first-child {
                    width: 100%;
                    margin-right: 0;
                }

                &.active-menu::before {
                    position: absolute;
                    content: " ";
                    width: 23px;
                    height: 8px;
                    top: 50%;
                    transform: translateY(-50%);
                    left: -33px;
                    background-image: url("../assets/business/arrow.png");
                }
            }
        }


        .business-inner {
            background-image: url("../assets/business/bg.png");
            background-position: bottom;
            background-repeat: no-repeat;
            padding: 3.5% 5.2% 50%;


            .container {
                flex: 1;
                margin-left: 8%;
                position: relative;
            }

            .sub-title {
                font-size: 36px;
                color: #006EC3;
                line-height: 2.78;
            }

            .join {
                display: flex;
                justify-content: flex-end;
                margin-right: 30px;
                margin-left: auto;
            }

            .detail {
                .join {
                    display: flex;
                    justify-content: flex-end;
                    margin-right: 30px;
                }

                .text {
                    font-size: 18px;
                    line-height: 2;
                }

                .box {
                    width: 100%;
                    // border: 1px solid #E9F2FF;
                    // padding: 20px 40px;

                    .addr,
                    .type {
                        margin-bottom: 15px;

                        span {
                            font-size: 14px;
                            display: inline-block;
                            margin-right: 20px;
                            color: #333;
                        }
                    }

                    .imgs {
                        width: 100%;
                        // height: 300px;
                        // background: #ECF5FF;
                        border-radius: 5px;
                        // padding: 20px 20px 0;
                        flex-wrap: wrap;
                        justify-content: space-around;
                        display: flex;

                        .items {
                            cursor: pointer;
                            display: flex;
                            flex-direction: column;
                            align-items: center;
                            font-size: 16px;
                            font-weight: bold;
                            margin-bottom: 40px;

                            img {
                                width: 300px;
                                height: 200px;
                                border-radius: 3px;
                                margin-bottom: 30px;
                            }
                        }
                    }
                }

                .box2 {
                    line-height: 40px;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    font-size: 18px;

                    p {
                        text-indent: 2em;
                    }

                    img {

                        width: 400px;
                        margin: 30px auto;
                    }
                }
            }

        }

        .sidebar {
            flex-shrink: 0;
            align-self: flex-start;
            width: 34.9%;
            box-shadow: 0px 2px 35px 2px rgba(30, 19, 15, 0.11);

            .sidebar-title {
                padding-left: 11.4%;
                color: #fff;
                font-size: 30px;
                line-height: 3.33;
                background-image: url("../assets/business/sidebar-title.png");
                background-size: 100% 100%;
                background-repeat: no-repeat;
            }

            .sidebar-list {
                background-image: url("../assets/business/sidebar.png");
                background-position: bottom;
                background-repeat: no-repeat;
                background-color: #E9F2FF;
            }

            .sidebar-itme {
                line-height: 5;
                font-size: 24px;
                border-bottom: 1px solid #fff;
                padding-left: 7.8%;
                position: relative;

                &:last-child {
                    border-bottom: 1px solid transparent;
                }

                &.acitve-sidebar-item {
                    background-color: #fff;

                    &::after {
                        position: absolute;
                        content: ' ';
                        right: -8.2%;
                        top: 50%;
                        transform: translateY(-50%);
                        width: 26px;
                        height: 24px;
                        background-image: url("../assets/business/double-arrow.png");
                    }
                }
            }

            .sidebar-icon {
                width: 17%;
                margin-right: 5.1%;
            }


        }


        @media screen and (max-width:1850px) {
            .banner {
                // height: 530px;

                .title {
                    font-size: 40px;
                }


                .menu-item {
                    font-size: 25px;
                }
            }


            .business-inner {
                .sub-title {
                    font-size: 30px;
                }

                .text {
                    font-size: 15px;
                }
            }

            .sidebar {
                .sidebar-title {
                    font-size: 25px;
                }

                .sidebar-itme {
                    font-size: 20px;

                    &.acitve-sidebar-item {

                        &::after {
                            width: 22px;
                            height: 20px;
                            background-size: 100% 100%;
                        }
                    }
                }

                .sidebar-icon {
                    width: 14%;
                }


            }
        }

        @media screen and (max-width:1450px) {
            .banner {
                // height: 530px;

                .title {
                    font-size: 31px;
                }

                .menu-item {
                    font-size: 20px;
                }
            }


            .business-inner {
                .sub-title {
                    font-size: 23px;
                }

                .text {
                    font-size: 14px;
                }
            }

            .sidebar {
                .sidebar-title {
                    font-size: 20px;
                }

                .sidebar-itme {
                    font-size: 16px;
                }
            }
        }

        @media screen and (max-width:1150px) {
            .banner {
                // height: 530px;

                .title {
                    font-size: 25px;
                }


                .menu-item {
                    font-size: 16px;
                }
            }


            .business-inner {
                .sub-title {
                    font-size: 20px;
                }

                .text {
                    font-size: 12px;
                }
            }

            .sidebar {
                .sidebar-title {
                    font-size: 16px;
                }

                .sidebar-itme {
                    font-size: 12px;

                    &.acitve-sidebar-item {

                        &::after {
                            width: 14px;
                            height: 13px;
                        }
                    }
                }
            }
        }
    }
</style>